import React, { useState } from "react";
import {
    Row,
    Col,
    Label,
    Button,
    FormGroup,
    CustomInput,
} from "reactstrap";
import { Trans, useTranslation } from 'react-i18next';

const StepZero = ({ jumpToStep }) => {
    const { t } = useTranslation();
    const [isChecked, setIsChecked] = useState(false);

    return (
        <div className="step step0 mt-5">
            <Row className="justify-content-md-center">
                <Col lg="6">
                    <p>
                        <Trans i18nKey="userDataForm.view.stepZero.form.label.declarationPoint1">
                            By providing this information, you acknowledge and agree that it will be provided to the best of your knowledge and ability. We strive to ensure that all information is accurate and truthful.
                        </Trans>
                    </p>
                    <p>
                        <Trans i18nKey="userDataForm.view.stepZero.form.label.declarationPoint2">
                            Please be aware that providing false information or misrepresenting the truth can have significant consequences. We urge all users to verify the information they provide and to use this platform responsibly.
                        </Trans>
                    </p>
                    <p>
                        <Trans i18nKey="userDataForm.view.stepZero.form.label.declarationPoint3">
                            The liability for any misinformation or errors lies solely with the individual providing the information. We assume no responsibility for the consequences of incorrect or misleading information provided by users.
                        </Trans>
                    </p>
                    <p>
                        <Trans i18nKey="userDataForm.view.stepZero.form.label.declarationPoint4">
                            By clicking <strong>'Next'</strong>, you consent to these terms and affirm that you are fully aware of the implications of providing inaccurate or false information.
                        </Trans>
                    </p>
                    <FormGroup>
                        <Label check>
                           <CustomInput
                                type="checkbox"
                                name="terms_agreement"
                                id="terms_agreement"
                                checked={isChecked}
                                onChange={() => setIsChecked(!isChecked)}
                            />
                            {t("userDataForm.view.stepZero.form.label.declarationAgreement")}
                        </Label>
                    </FormGroup>
                </Col>
            </Row>
            <Button
                className="btn btn-next btn-ml pull-right"
                style={{ color: "#ffffff", backgroundColor: "#000a60" }}
                type="submit"
                onClick={() => {
                    if (isChecked) {
                        jumpToStep(1);
                    }
                }}
                disabled={!isChecked}
            >
                {t("userDataForm.view.stepZero.form.button.next")}
            </Button>
        </div>
    );
};

export default StepZero;